import * as d3 from 'd3'

export default {
  methods: {

    draw_ChartCanvas(props) {

      let canvas = this.canvasChart
      .append('g')
      .attr('id', `CHART_${props.group}`)
      .attr('transform', `translate(${props.x +.5}, ${props.y + .5})`)

      canvas
      .append('text')
      .attr('id', `TITLE_MAIN_${props.group}`)
      .attr('x', 0) .attr('y', -25)
      .style('font-size', 15)
      .style('fill', '#000')
      .text(`${props.group}`)

      canvas
      .append('text')
      .attr('id', `TITLE_SUB_${props.group}`)
      .attr('x', this.getNode(`#TITLE_MAIN_${props.group}`, 'width') + 7) .attr('y', -25)
      .style('font-size', 11).style('fill', '#858585')
      .text(this.title.sub.name)

      if(this.title.sub.visible == 'Y') {
        canvas
        .append('text')
        .attr('x', this.getNode(`#TITLE_MAIN_${props.group}`, 'width') + this.getNode(`#TITLE_SUB_${props.group}`, 'width') + 12) .attr('y', -25)
        .style('font-size', 11).style('fill', '#F35E90')
        .text(props.TOTAL)
        .call(this.call_LINK, props.group, this.title.sub.filter)
      }

      this.draw_ChartAxis(props) //-----> below
      this.draw_Legends(props) //-----> below
      this.draw_Grid(props) //-----> below
    },


    draw_Legends(props) {
      
      let itemGroup = d3.select(`#CHART_${props.group}`)
      .append('g')
      .attr('id', `LEGEND_${props.group}`)
      .attr('transform', `translate(0,-15)`)
      
      let x_ = 0
      this.legends.forEach((d,i)=> {

        let pro = (props[d.code]/props.TOTAL) * d.bSize

        let item = itemGroup
        .append('g')
        .attr('id', `ITEM_${i}`)
        .attr('transform', `translate(${x_}, 0)`)

        item
        .append('rect')
        .attr('x', 0).attr('y', 0)
        .attr('width', 8).attr('height', 8).attr('fill', d.color)
        
        item
        .append('text')
        .attr('id', `ITEM_NAME_${i}`)
        .attr('x', 10).attr('y', 7.5)
        .style('font-size', 10).style('fill', '#757575')
        .text(d.name)

        let bx = this.getNode(`#ITEM_NAME_${i}`,'width') + 15
        item
        .append('rect')
        .attr('x', bx).attr('y', 0)
        .attr('width', d.bSize).attr('height', 10).attr('fill', '#F4F5F5')

        item
        .append('rect')
        .attr('x', bx).attr('y', 0)
        .attr('width', pro).attr('height', 8).attr('fill', d.color)

        item
        .append('text')
        .attr('x', (pro < d.alignPro) ? bx + pro + 2 : bx + pro -2).attr('y', 7.5)
        .attr('text-anchor', (pro < d.alignPro) ? 'start' : 'end')
        .style('font-size', 10).style('fill', '#333')
        .text(props[d.code])
        .call(this.call_LINK, props.group, d.filter)

        x_ = x_ + this.getNode(`#ITEM_${i}`, 'width') + 15
      })
    },


    draw_ChartAxis(props) {
      
      let axis = d3.select(`#CHART_${props.group}`)
      axis
      .append('line')
      .attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', this.chart.height)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)

      axis
      .append('line')
      .attr('x1', 0).attr('x2', this.chart.width).attr('y1', this.chart.height).attr('y2', this.chart.height)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)

      axis
      .append('line')
      .attr('x1', this.chart.width).attr('x2', this.chart.width).attr('y1', 0).attr('y2', this.chart.height)
      .attr('stroke', '#757575' ).attr('stroke-width', .5).attr('opacity', 1)

      // Primary Axis
      axis
      .append('text')
      .attr('transform', `translate(${-23}, ${this.chart.height/2 + 4}) rotate(-90)`)
      .style('font-size', 10).style('fill', '#000')
      .attr('text-anchor', 'middle')
      .text(this.primary.name)

      // secondary Axis
      axis
      .append('text')
      .attr('transform', `translate(${this.chart.width + 30}, ${this.chart.height/2 + 4}) rotate(-90)`)
      .style('font-size', 10).style('fill', '#000')
      .attr('text-anchor', 'middle')
      .text(this.secondary.name)
    },


    draw_Grid(props) {
      let grid = this.chart.height / 5

      let Grids = d3.select(`#CHART_${props.group}`)

      for(let i=0; i<6; i++) {
        Grids // Grid
        .append('line')
        .attr('x1', 0).attr('x2', this.chart.width)
        .attr('y1', grid * i).attr('y2', grid * i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
        .attr('opacity', .5)

        Grids // Primary Axis
        .append('text')
        .attr('x', -2)
        .attr('y', this.chart.height - (grid * i) + 3)  
        .style('font-size', 9).style('fill', '#757575')
        .attr('text-anchor', 'end')
        .text((this.primary.max * (i*.2)).toFixed(0))

        Grids // secondary Axis
        .append('text')
        .attr('x', this.chart.width + 2)
        .attr('y', this.chart.height - (grid * i) + 3)
        .style('font-size', 9).style('fill', '#757575')
        .attr('text-anchor', 'start')
        .text((this.secondary.max * (i*.2)).toFixed(0))
      }
    },


  }
}
